// extracted by mini-css-extract-plugin
export default {"container":"apply_container__hYTpJ","bg_container":"apply_bg_container__xuByr","title":"apply_title__IgsF9"};